import { render, staticRenderFns } from "./form_detail_subcategories_marketplace_component.vue?vue&type=template&id=0df64406&scoped=true"
import script from "./form_detail_subcategories_marketplace_component.vue?vue&type=script&lang=js"
export * from "./form_detail_subcategories_marketplace_component.vue?vue&type=script&lang=js"
import style0 from "./form_detail_subcategories_marketplace_component.vue?vue&type=style&index=0&id=0df64406&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df64406",
  null
  
)

export default component.exports